import { _defineProperty } from "./index13.js";
var Nmcs = class {
	constructor(rules) {
		_defineProperty(this, "rootState", void 0);
		_defineProperty(this, "rules", void 0);
		this.rules = rules;
		this.rootState = this.rules.initialState;
	}
	runSearch({ state, level, rng }) {
		if (!state) state = this.rootState;
		const currentState = this.rules.cloneState(state);
		let bestReward = -Infinity;
		let bestSolution = this.rootState;
		let iters = 0;
		const nRollouts = 1;
		if (level === 0) {
			let { reward: bestInnerReward, solution: bestInnerSolution } = this.rollout(currentState, rng);
			for (let i = 1; i < nRollouts; i++) {
				const { reward, solution } = this.rollout(currentState, rng);
				if (reward > bestInnerReward) {
					bestInnerReward = reward;
					bestInnerSolution = solution;
				}
			}
			return {
				reward: bestInnerReward,
				solution: bestInnerSolution,
				iters: nRollouts
			};
		} else {
			let validActions = this.rules.getValidActions(currentState);
			if (validActions.length === 0) {
				this.rules.finalAction(currentState);
				return {
					reward: -1 * this.rules.getCost(currentState),
					solution: currentState,
					iters
				};
			}
			while (validActions.length > 0) {
				let bestInnerReward = -Infinity;
				let bestInnerSolution = this.rules.cloneState(this.rootState);
				let bestAction = validActions[0];
				for (const action of validActions) {
					const innerState = this.rules.cloneState(currentState);
					this.rules.updateState(innerState, action);
					const { reward, solution, iters: rolloutIters } = this.runSearch({
						state: innerState,
						level: level - 1,
						rng
					});
					const rewardAdjusted = reward - this.rules.getActionCost(action);
					if (rewardAdjusted > bestInnerReward) {
						bestInnerReward = rewardAdjusted;
						bestAction = action;
						bestInnerSolution = solution;
					}
					iters += rolloutIters;
				}
				if (bestInnerReward > bestReward) {
					bestReward = bestInnerReward;
					bestSolution = bestInnerSolution;
				}
				this.rules.updateState(currentState, bestAction);
				validActions = this.rules.getValidActions(currentState);
			}
			return {
				reward: bestReward,
				solution: bestSolution,
				iters
			};
		}
	}
	rollout(state, rng) {
		const solution = this.rules.cloneState(state);
		let validActions = this.rules.getValidActions(state);
		while (validActions.length > 0) {
			const action = this.rules.pickActionWithPolicy(validActions, rng);
			this.rules.updateState(solution, action);
			validActions = this.rules.getValidActions(solution);
		}
		this.rules.finalAction(solution);
		return {
			reward: -1 * this.rules.getCost(solution),
			solution
		};
	}
};
export { Nmcs };

//# sourceMappingURL=index165.js.map